import React, { useEffect, useState } from 'react';
import { Table, Spin, Button, Switch, Modal, Typography, message } from 'antd';
import get from 'lodash/get';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { userMangement } from '../../redux/actions/authActions';
import { generatePaginationObj } from '../../utilities/helpers';
import BrandInfo from '../../components/superAdminUser/brandInfo';
import AddBrand from '../../components/superAdminUser/addbrand';
import { COMPANY_SUBSCRIPTION_UPDATE_SUCCESS } from '../../constants/messages';

const { Text } = Typography;
const { confirm } = Modal;

function SuperAdminBrandList() {
  const [loading, setLoading] = useState(false);
  const [addBrandModal, setAddBrandModal] = useState(false);

  const [brandsDetailModal, setBrandsDetailModal] = useState({
    visible: false,
    data: null,
  });

  const [brands, setBrands] = useState({
    data: [],
    pagination: {
      offset: 0,
      limit: 10,
      total: 0,
      current: 1,
    },
  });

  const toggleBrandModal = () => {
    setAddBrandModal(!addBrandModal);
  };

  const toggleBrandDetailsModal = (data = null) => {
    setBrandsDetailModal({
      visible: !get(brandsDetailModal, 'visible'),
      data,
    });
  };

  const dispatch = useDispatch();

  const getBrandList = (page = 1) => {
    setLoading(true);
    const pageObj = generatePaginationObj(
      page,
      get(brands, 'pagination.limit')
    );
    dispatch(
      userMangement('list.companies', {
        ...pageObj,
      })
    )
      .then((result) => {
        setLoading(false);
        setBrands({
          data: get(result, 'data', []),
          pagination: {
            ...pageObj,
            total: get(result, 'total'),
            current: page,
          },
        });
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const changeSubscription = (id, status) => {
    setLoading(true);
    dispatch(
      userMangement('update.company', {
        company_id: id,
        is_active: status,
      })
    )
      .then(() => {
        message.success(COMPANY_SUBSCRIPTION_UPDATE_SUCCESS);
        getBrandList(get(brands, 'pagination.current'));
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const onChangeSubscriptionStatus = (id, status) => {
    confirm({
      title: 'Aur you Sure?',
      icon: <ExclamationCircleFilled />,
      content: 'You want change Subscription status of this brand!',
      okText: 'Yes',
      cancelText: 'No',
      onOk() {
        changeSubscription(id, status);
      },
      onCancel() {},
    });
  };

  useEffect(() => {
    getBrandList();
  }, []);

  return (
    <div className="team-detail-container">
      <Spin spinning={loading}>
        <div className="top-section">
          <Button className="default-btn" onClick={() => toggleBrandModal()}>
            + Add Brand
          </Button>
        </div>

        <Table
          rowKey="id"
          columns={[
            {
              title: 'Name',
              key: 'name',
              dataIndex: 'name',
              render: (text, record) => (
                <Text
                  className="text-theme-color"
                  onClick={() => {
                    toggleBrandDetailsModal(record);
                  }}
                >
                  {text}
                </Text>
              ),
            },
            {
              title: 'Date',
              key: 'created_at',
              dataIndex: 'created_at',
              render: (createdAt) =>
                moment(createdAt).format('DD/MM/YYYY (HH:mm A)'),
            },
            {
              title: 'Subscription',
              key: 'is_active',
              dataIndex: 'is_active',
              render: (active, record) => (
                <Switch
                  checked={active}
                  onChange={(status) => {
                    onChangeSubscriptionStatus(get(record, 'id'), status);
                  }}
                />
              ),
            },
          ]}
          dataSource={get(brands, 'data')}
          pagination={{
            showSizeChanger: false,
            position: ['bottomCenter'],
            hideOnSinglePage: true,
            pageSize: get(brands, 'pagination.limit'),
            total: get(brands, 'pagination.total'),
            current: get(brands, 'pagination.current'),
          }}
          onChange={(paginationObj) => {
            getBrandList(get(paginationObj, 'current'));
          }}
        />

        <Modal
          width="35%"
          className="common-modal"
          destroyOnClose
          closable={false}
          open={addBrandModal}
          onOk={toggleBrandModal}
          onCancel={toggleBrandModal}
          footer={null}
          maskClosable={false}
        >
          <AddBrand onClose={toggleBrandModal} onRefresh={getBrandList} />
        </Modal>

        <Modal
          width="45%"
          className="common-modal"
          destroyOnClose
          open={get(brandsDetailModal, 'visible')}
          onOk={toggleBrandDetailsModal}
          onCancel={toggleBrandDetailsModal}
          footer={null}
          maskClosable={false}
        >
          <BrandInfo
            brand={get(brandsDetailModal, 'data')}
            onClose={toggleBrandDetailsModal}
          />
        </Modal>
      </Spin>
    </div>
  );
}

export default SuperAdminBrandList;
